import './style.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CSSProperties } from 'react';
import { EffectCards, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';

interface SwiperImgProps {
  images: string[];
}

const SwiperImg: React.FC<SwiperImgProps> = ({ images }) => {
  const validImages = images.filter(img => typeof img === 'string' && img.startsWith('http'));

  if (validImages.length === 0) {
    return null;
  }

  const isLoopingEnabled = validImages.length > 1;

  const renderImage = validImages.map((img, index) => {
    return (
      <SwiperSlide key={`${img}-${index}`}>
        <picture>
          <source type='image/jpg' srcSet={img} />
          <img src={img} alt={`slide-img-${index}`} loading="lazy" />
        </picture>
      </SwiperSlide>
    );
  });

  return (
    <>
      <Swiper
        style={
          {
            '--swiper-navigation-color': '#fff',
            '--swiper-pagination-color': '#fff'
          } as CSSProperties
        }
        speed={2000}
        grabCursor={true}
        effect={'cards'}
        loop={isLoopingEnabled}
        modules={[EffectCards, Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false
        }}
        className='mySwiper'
      >
        {renderImage}
      </Swiper>
    </>
  );
};

export default SwiperImg;